import React from 'react';

const DynamicHTMLRenderer = ( content ) => {
	const htmlContent = content;

	// Create an array to hold the JSX elements
	const elements = [];
	// Parse the HTML content and generate React elements
	const parser = new DOMParser();
	const parsedHTML = parser.parseFromString(htmlContent, 'text/html');

	for (const node of parsedHTML.body.childNodes) {
		elements.push(React.createElement(node.tagName?.toLowerCase(), {
			key: elements.length,
			className: 'event-pera',
			dangerouslySetInnerHTML: { __html: node.innerHTML }

		}));
	}

	return (
		<React.Fragment>
			{elements}
		</React.Fragment>
	);
};

export default DynamicHTMLRenderer;
